import orderBy from 'lodash/orderBy';
import { ClientFacilityOffering } from '@pass-frontend/data-access/state-management/apollo';
import {
  GYM_SORT_CRITERIA,
  SORT_CRITERIA,
  SORT_DIRECTION,
  SortOfferingsDataFn,
} from '@pass-frontend/data-access/types';

export const sortFacilityOfferingsData: SortOfferingsDataFn<
  ClientFacilityOffering,
  GYM_SORT_CRITERIA
> = (
  offeringsList: ClientFacilityOffering[],
  sortCriterion: GYM_SORT_CRITERIA = SORT_CRITERIA.A_TO_Z,
  sortDirection = SORT_DIRECTION.ASC,
) => {
  const sortDirectionLowerCase = sortDirection.toLowerCase() as 'asc' | 'desc';
  if (sortCriterion === SORT_CRITERIA.DISTANCE) {
    return orderBy(
      offeringsList,
      ['location.distanceFromMember', 'name'],
      [sortDirectionLowerCase, sortDirectionLowerCase],
    );
  } else if (sortCriterion === SORT_CRITERIA.A_TO_Z) {
    return orderBy(
      offeringsList,
      ['name', 'location.distanceFromMember'],
      [sortDirectionLowerCase, sortDirectionLowerCase],
    );
  }
  console.warn('INVALID SORTING');
  return offeringsList;
};
